import { HttpLink } from "apollo-link-http";
import { setContext } from "@apollo/client/link/context";
// New Imports
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  useQuery,
  ApolloLink,
  gql,
} from "@apollo/client";
import { useSelector } from "react-redux";
const ApolloWrapper = ({children}) => {
  const BackendApiBaseUrl = process.env.REACT_APP_API_URL;

  const authTokenValue = useSelector(
    (state) => state.authReducer.user.authToken
  );
  const userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const ImpersonationId = useSelector(
    (state) => state.authReducer.impersonationId
  );

  const httpLink = new HttpLink({
    uri: `${BackendApiBaseUrl}/query`,
  });

  const authLink = setContext((_, { headers }) => {
    if (ImpersonationId) {
      return {
        headers: {
          ...headers,
          authorization: authTokenValue ? `${authTokenValue}` : "",
          email: userProfile?.EmailAddress,
          impersonationid: ImpersonationId,
        },
      };
    } else {
      return {
        headers: {
          ...headers,
          authorization: authTokenValue ? `${authTokenValue}` : "",
          email: userProfile?.EmailAddress,
        },
      };
    }
  });

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: authLink.concat(httpLink),
  });

  return (
    <ApolloProvider client={client}>
      {children}
    </ApolloProvider>
  );
};

export { ApolloWrapper};